import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../../constants/react_app_consts";

const initialState = {
    update_document_info: { status: "idle" },
}

export const update_document_info_Slice = createSlice({
    name: "update_document_info",
    initialState,
    reducers: {
        success_update_document_info: (state, action) => {
            state.update_document_info = { status: app_consts.SUCCESS, data: action.payload };
        },
        fail_update_document_info: (state, action) => {
            state.update_document_info = { status: app_consts.FAIL, message: action.payload };
        },
        reset_update_document_info: (state) => {
            state.update_document_info = { status: app_consts.IDLE }
        },
        loading_update_document_info: (state) => {
            state.update_document_info = { status: app_consts.LOADING }
        },
    }
})

export const { success_update_document_info, fail_update_document_info, reset_update_document_info, loading_update_document_info } = update_document_info_Slice.actions;

export default update_document_info_Slice.reducer;